import { proxy } from 'valtio';

export const showtimeState = proxy({
    showShowtime: false,
    showShowtimeAndActiveEvent: false,
});
